import { type JsonDataItem } from 'types';
import { externalQuery } from '../externalQuery';

import env from 'env';

export const getAddressPredictionDetails = async ({ id }: JsonDataItem) => {
  const data = await externalQuery(`https://api.psma.com.au/v1/predictive/address/${id}`, {
    headers: {
      Authorization: env.GEOSCAPE_API_KEY,
    },
  });

  return data;
};
